import React from "react";
import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import { format } from "date-fns";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { Link, useParams } from "react-router-dom";
import { getDepartmentEmployeeAssetDetails } from "../../services/AssetService";
import { FaArrowLeft } from "react-icons/fa";
import { FaInfo } from "react-icons/fa";
import { CustomTooltip } from "../../components/CustomTooltip";
const EmployeeAssetDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setToatl] = useState(0);

  const [param, setParam] = useState({
    query: "",
    page: "1",
    page_size: "10",
  });

  const getAssetList = () => {
    setLoading(true);
    getDepartmentEmployeeAssetDetails(id, param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setToatl(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAssetList();
  }, [param]);

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  return (
    <div className="card">
      <div className="px-4 py-3 d-flex justify-content-between gap-2">
        <div className="d-flex gap-1">
          <Link
            className="btn rounded-2 p-2 btn-outline-light align-self-center"
            to="/my-asset/departmentEmp-asset"
          >
            <FaArrowLeft className="text-dark"/>
          </Link>
          <div>
            <div>
              <span
                className="text-darker fw-medium"
                style={{ fontSize: "0.85rem" }}
              >
                {data?.fullname || "-"}
              </span>
            </div>
            <div style={{ fontSize: "0.7rem" }}>
              <span className="text-dark fw-medium">
                ({data?.email || "-"})
              </span>
            </div>
          </div>
        </div>

        <div className="flex-fill flex-sm-grow-0">
          <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
        </div>
      </div>
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center my-4 text-danger">{error}</div>
      ) : data?.assets?.length > 0 ? (
        <div className="table-responsive">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="table-light custom-thead">
              <tr>
                <th>Asset Number</th>
                <th>Name</th>
                <th>Cost (₹)</th>
                <th>Allocate By</th>
                <th>Allocate Date</th>
              </tr>
            </thead>
            <tbody>
              {data?.assets?.map((asset, index) => (
                <tr key={index}>
                  <td>
                    {" "}
                    <Link
                      to={`/asset/${asset?.id}/basic-details`}
                      className="fw-bold text-primary"
                    >
                      {asset?.asset_number || "-"}
                    </Link>
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-1 cursor-pointer">
                      <span>{asset?.name || "-"}</span>
                      <CustomTooltip
                        title={
                          <div>
                            <div>
                              <strong>Brand:</strong> {asset?.brand || "-"}
                            </div>
                            <div>
                              <strong>Serial Number:</strong>{" "}
                              {asset?.serial_number || "-"}
                            </div>
                            <div>
                              <strong>Manual Asset ID:</strong>{" "}
                              {asset?.manual_asset_id || "-"}
                            </div>
                            <div>
                              <strong>Model No.:</strong>{" "}
                              {asset?.model_number || "-"}
                            </div>
                          </div>
                        }
                        placement="right"
                      >
                        <span
                          className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                          style={{
                            cursor: "pointer",
                            padding: "0.2rem 0.2rem",
                          }}
                        >
                          <FaInfo size={9} className="text-dark" />
                        </span>
                      </CustomTooltip>
                    </div>
                  </td>
                  <td>{`₹${asset?.purchase_cost}` || "-"}</td>
                  <td>{asset.allocated_by?.name || "-"}</td>
                  <td>
                    {asset.allocated_at
                      ? format(asset?.allocated_at, "dd MMM yyy")
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center my-4">No data found</div>
      )}
      {!loading && data?.assets?.length > 0 && (
        <div className="p-4">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default EmployeeAssetDetails;
